import { render, staticRenderFns } from "./icon-facebook.vue?vue&type=template&id=713b8e38&"
import script from "./icon-facebook.vue?vue&type=script&lang=ts&"
export * from "./icon-facebook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports